(function ($) {

    var windowWidth = $(window).width();
    var stickyContent = $('.product__summary');
    var wrapper = $('.product__right');
    var gallery = $('.product__left');

    if(!stickyContent.length){
        return
    }

    var contentHeight = stickyContent.outerHeight(),
        contentTop = $(wrapper).offset().top,
        wrapperHeight = wrapper.outerHeight(),
        heightDifference = contentHeight - $(window).height(),
        topOffset = 30,
        lastScroll = 0,
        currentMargin = 0,
        currentDistanceFromBottomUp = $(stickyContent).offset().top,
        currentDistanceFromBottomDown = contentTop + contentHeight,
        scroll = $(document).scrollTop(),
        bottomScroll = scroll + $(window).height();


    function content_scroll_sticky() {
        contentHeight = stickyContent.outerHeight();
        contentTop = $(wrapper).offset().top;
        wrapperHeight = wrapper.outerHeight();
        heightDifference = contentHeight - $(window).height();
        lastScroll = 0;
        currentMargin = 0;
        currentDistanceFromBottomUp = $(stickyContent).offset().top;
        currentDistanceFromBottomDown = contentTop + contentHeight;
        scroll = $(document).scrollTop();
        bottomScroll = scroll + $(window).height();

        if (contentHeight > $(window).height() && contentHeight < gallery.outerHeight() - topOffset) {
            if(!$('.scrollMargin').length) {
                $("<div class='scrollMargin'></div>").insertBefore(stickyContent);
            }
        } else {
            stickyContent.css({'top': 30+'px'});
        }

        function setScrollUp(){
            if (contentHeight > $(window).height() && contentHeight < gallery.outerHeight() - topOffset){
                stickyContent.css({'bottom': -heightDifference - topOffset, 'top': ''});

                if (scroll < currentDistanceFromBottomUp && scroll < currentMargin + contentTop && scroll > contentTop - topOffset){
                    $('.scrollMargin').css({'margin-top': scroll - contentTop + topOffset});
                    currentMargin = $(stickyContent).offset().top - $(wrapper).offset().top;
                } else if(scroll + topOffset < contentTop)  {
                    $('.scrollMargin').css({'margin-top': '0'});
                } else if(bottomScroll > contentTop + wrapperHeight) {
                    $('.scrollMargin').css({'margin-top': wrapperHeight - contentHeight});
                    currentMargin = wrapperHeight - contentHeight;
                }

                currentDistanceFromBottomUp = $(stickyContent).offset().top - topOffset;
            }
        }

        function setScrollDown(){
            if (contentHeight > $(window).height()  && contentHeight < gallery.outerHeight() - topOffset){
                stickyContent.css({'bottom': '', 'top': -heightDifference})

                if (bottomScroll > currentDistanceFromBottomDown && bottomScroll < wrapperHeight + contentTop){
                    $('.scrollMargin').css({'margin-top': scroll - contentTop - heightDifference});
                    currentMargin = $(stickyContent).offset().top - $(wrapper).offset().top;
                } else if(scroll + topOffset < contentTop)  {
                    $('.scrollMargin').css({'margin-top': '0'});
                } else if(bottomScroll > contentTop + wrapperHeight) {
                    $('.scrollMargin').css({'margin-top': wrapperHeight - contentHeight});
                    currentMargin = wrapperHeight - contentHeight;
                }

                currentDistanceFromBottomDown = $(stickyContent).offset().top + stickyContent.outerHeight();
            }
        }

        setScrollUp();
        setScrollDown();


        $(document).on('scroll', function () {
            scroll = $(document).scrollTop();
            bottomScroll = scroll + $(window).height();
            if(lastScroll - scroll > 0) { //scroll up
                setScrollUp()
            } else { //scroll down
                setScrollDown()
            }
            lastScroll = scroll;
        });


    }

    window.addEventListener('resize', () => {
        if ($(window).width() == windowWidth) return;
        setTimeout(() => {
            content_scroll_sticky();
        }, 10)
    });
    $("[data-show-more-gallery]").click(function () {
        setTimeout(() => {
            content_scroll_sticky();
        }, 10)
    })
    $(".product__colors_color-button").click(function () {
        setTimeout(() => {
            content_scroll_sticky();
        }, 10)
    })
    $(document).gp_ready(function (){
        if($('.product__summary').length) {
            content_scroll_sticky();
        }
    })

})(jQuery);